import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f6a8e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Typ"),
    /*#__PURE__*/_createElementVNode("th", null, "LEI"),
    /*#__PURE__*/_createElementVNode("th", null, "Name der Entität"),
    /*#__PURE__*/_createElementVNode("th", null, "Preis / Jahr")
  ])
], -1))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  id: "placeholder-row"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "material-icons",
    style: {"vertical-align":"bottom"}
  }, "info"),
  /*#__PURE__*/_createTextVNode(" Keine LEIs beantragt ")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "sum" }, "Summe:", -1))
const _hoisted_11 = { class: "sum" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", null, [
      _hoisted_1,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.registrationDetails.lei
          }, [
            _createElementVNode("td", null, _toDisplayString(_ctx.types[index]), 1),
            _createElementVNode("td", {
              onClick: ($event: any) => (_ctx.showDetails(item.registrationDetails.lei))
            }, _toDisplayString(item.registrationDetails.lei), 9, _hoisted_2),
            _createElementVNode("td", null, _toDisplayString(item.legalEntity.legalName), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.price) + " €", 1),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "delete",
                onClick: ($event: any) => (_ctx.deleteItem(item.registrationDetails.lei))
              }, " Löschen ", 8, _hoisted_3)
            ])
          ]))
        }), 128)),
        (_ctx.items.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      (_ctx.items.length > 0)
        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_7, [
            _createElementVNode("tr", null, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.sum) + " €", 1),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_base_button, {
      class: "button",
      title: 'Kaufen',
      onClick: _ctx.buy,
      disabled: _ctx.items.length === 0
    }, null, 8, ["onClick", "disabled"])
  ], 64))
}